import { render, staticRenderFns } from "./DocumentEditor.vue?vue&type=template&id=7b349e9b&scoped=true&"
import script from "./DocumentEditor.vue?vue&type=script&lang=ts&"
export * from "./DocumentEditor.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentEditor.vue?vue&type=style&index=0&id=7b349e9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b349e9b",
  null
  
)

export default component.exports